import { gql } from '@apollo/client';

export function modifyAmendment() {
  return gql`
    mutation modifyAmendment(
      $entityId: String!
      $cancellationEffectiveDate: Date!
      $cancellationIssuanceDate: Date!
      $cancellationReason: Production_CancellationReasons!
    ) {
      production {
        actions {
          modifyAmendment(
            amendmentId: $entityId
            cancellationEffectiveDate: $cancellationEffectiveDate
            cancellationIssuanceDate: $cancellationIssuanceDate
            cancellationReason: $cancellationReason
          ) {
            id
          }
        }
      }
    }
  `;
}

export function recalculateCancellationAmendment() {
  return gql`
    mutation recalculateCancellationAmendment(
      $entityId: String!
      $cancellationEffectiveDate: Date!
      $cancellationIssuanceDate: Date!
      $cancellationReason: Production_CancellationReasons!
    ) {
      production {
        actions {
          recalculateCancellationAmendment(
            amendmentId: $entityId
            cancellationEffectiveDate: $cancellationEffectiveDate
            cancellationIssuanceDate: $cancellationIssuanceDate
            cancellationReason: $cancellationReason
          ) {
            id
          }
        }
      }
    }
  `;
}
